import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// جلب رابط الـ API من ملف .env (تأكد من أنه يشير إلى https://desc.ag.edu.iq/api/)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://desc.ag.edu.iq/api/';

// إنشاء Thunk لجلب بيانات التقييم
export const fetchAssessmentResults = createAsyncThunk(
  'assessment/fetchResults',
  async (params = {}, { rejectWithValue }) => {
    try {
      // جلب التوكن المحفوظ في الـ LocalStorage
      const token = localStorage.getItem('userToken');

      // إعداد المعاملات (Query Params) بناءً على ما يتم تمريره، مع توفير قيم افتراضية
      const queryParams = {
        page: params.page || 1,
        perPage: params.perPage || 10000, // قيمة افتراضية
        ...(params.classId && { classId: params.classId }) // إضافة classId فقط إذا كان موجوداً
      };

      // إرسال طلب GET مع تمرير التوكن في الـ Headers
      const response = await axios.get(`${API_BASE_URL}assessment-results`, {
        params: queryParams,
        headers: {
          Authorization: `Bearer ${token}` // إضافة المصادقة
        }
      });

      // إرجاع البيانات (التي ستحتوي على data, links, meta كما في الصورة)
      return response.data;
    } catch (error) {
      console.error("Fetch Assessment Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "فشل جلب بيانات التقييم الوصفي"
      );
    }
  }
);

// إنشاء Thunk لحذف التقييم
export const deleteAssessmentResult = createAsyncThunk(
  'assessment/deleteResult',
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('userToken');
      
      // إرسال طلب DELETE مع تمرير الـ ID في الرابط بناءً على الـ Endpoint في Postman
      await axios.delete(`${API_BASE_URL}assessment-results/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // إرجاع الـ id حتى نتمكن من حذفه من الـ state في الـ reducer بدون إعادة تحميل الصفحة
      return id; 
    } catch (error) {
      console.error("Delete Assessment Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "فشل حذف التقييم"
      );
    }
  }
);

const assessmentSlice = createSlice({
  name: 'assessment',
  initialState: {
    results: [],       // مصفوفة البيانات (data)
    links: {},         // روابط الصفحات (links)
    meta: {},          // معلومات الصفحات (meta)
    loading: false,    // حالة التحميل
    error: null,       // حالة الخطأ
  },
  reducers: {
    // يمكنك إضافة reducers لتفريغ البيانات إذا لزم الأمر
    clearAssessmentData: (state) => {
      state.results = [];
      state.links = {};
      state.meta = {};
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // --- حالات جلب البيانات ---
      .addCase(fetchAssessmentResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssessmentResults.fulfilled, (state, action) => {
        state.loading = false;
        // حفظ البيانات في الحالات المخصصة لها بناءً على استجابة الخادم
        state.results = action.payload.data;
        state.links = action.payload.links;
        state.meta = action.payload.meta;
      })
      .addCase(fetchAssessmentResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // --- حالات حذف البيانات ---
      .addCase(deleteAssessmentResult.fulfilled, (state, action) => {
        // حذف العنصر من المصفوفة محلياً بمجرد نجاح الحذف في السيرفر
        state.results = state.results.filter(item => item.id !== action.payload);
      })
      .addCase(deleteAssessmentResult.rejected, (state, action) => {
        state.error = action.payload;
        // ملاحظة: يمكنك هنا ربط عرض رسالة خطأ للمستخدم (مثلاً باستخدام Toast/Snackbar)
      });
  },
});

export const { clearAssessmentData } = assessmentSlice.actions;
export default assessmentSlice.reducer;